module.exports = __webpack_public_path__ + "img/collar edges length.2e43eec6.png";